// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__jidXh","subtitle":"styles_subtitle__IvFJ8"};